<template>
  <div class="index-page-channel">
    <div class="top-banner">
      <img :src="require('@/assets/banner-bg.png')"  alt="">
    </div>
    <van-tabs v-model="active" @click="changeTab" line-width="20px" title-active-color="#333" title-inactive-color="#666">
      <van-tab title="COSE证书查询"></van-tab>
      <van-tab title="授权机构查询">
      </van-tab>
      <van-tab title="项目管理办法"></van-tab>
    </van-tabs>
    <div class="org-search">
        <h4>授权机构查询</h4>
        <van-form @submit="onSubmit">
          <van-field v-model="channel" name="channel" :rules="[{required: true, message: ''}]" clearable @clear="clearChannel" placeholder="请输入机构名称"/>
          <div style="margin: 1rem 0.32rem 0;"><van-button color="#0751A8" class="primary-btn" block type="info" native-type="submit">查询</van-button></div>
        </van-form>
    </div>
  </div>
</template>
<script>
import Tab from 'vant/lib/tab'
import Tabs from 'vant/lib/tabs'
import Field from 'vant/lib/field'
import Form from 'vant/lib/form'
import Button from 'vant/lib/button'
// import Loading from 'vant/lib/loading'
import 'vant/lib/tab/style'
import 'vant/lib/tabs/style'
import 'vant/lib/field/style'
import 'vant/lib/button/style'
// import 'vant/lib/loading/style'
// import {index} from "@/api/common.js";
// import { InfiniteScroll } from "element-ui"
export default {
  metaInfo: {
    title: '合作渠道查询'
  },
  data () {
    return {
      active: 1,
      channel: '',
      org: '',
    }
  },
  components: {
    'van-tabs':Tabs,
    'van-tab': Tab,
    'van-field': Field,
    'van-button': Button,
    'van-form': Form,
  },
  methods: {
    changeTab (value){
      this.$router.push({ path: value === 0 ? '/': '/projectM' })
    },
    onSubmit () {
      this.$router.push({ path: '/certResult', query: { name: this.channel } })
    },
    changeScroll (options) {
      const { scrollTop, isFixed } = options
      this.isFixed = isFixed
    },
    // load () {
    //   var that=this
    //   if (!that.loadMore) {
    //     return 
    //   }
    //   that.loading=true
    //   index("v2/cooperation",{
    //     page: that.page,
    //     name:that.channel,
    //     direction:that.org
    //   }).then((res) => {
    //     if (res.code == 0) {
    //       const dataList = JSON.parse(that.$Base64.decode(res.data))
    //       that.page === 1 ? that.tablelist = [] : ''
    //       // const dataSource = dataList.list.map(item => { return item })
    //       that.tablelist =that.tablelist.concat(dataList.list)
    //       console.log(that.tablelist)
    //       console.log(dataList)
    //       that.total=dataList.count
    //       if (that.tablelist.length < dataList.count) {
    //         that.page++
    //         that.loadMore = true
    //       } else {
    //         that.loadMore = false
    //       }
    //       that.loading=false
    //     }
    //   })
    // },
    // getlist(){
    //   var that=this
    //   that.loadMore = true
    //   that.page = 1
    //   this.load()
    // },
    clearChannel () {
      this.channel = ''
      this.getlist()
    },
    clearOrg () {
      this.org = ''
      this.getlist()
    }
  },
  created () {
    // this.load()
  }
}
</script>
<style lang="scss" scoped>
.index-page-channel {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color:#f6f6f6; 
  .top-banner {
    height: 1.44rem;
    width: 100%;
    // position: fixed;
    img {
      height: 1.44rem;
      width: 100%;
    }
  }
  .org-search {
    margin: 0.32rem 0.54rem 0 0.54rem;
    background-color: #fff;
    padding-bottom: 0.4rem;
    h4 {
      font-weight: 500;
      color: #191919;
      font-size: 0.32rem;
      padding: 0.4rem 0;
      line-height: 1;
      text-align: center;
    }
    .van-cell {
      background-color: #f9f9f9;
    margin: 0.32rem;
    width: auto;
    border-radius: 0.2rem;
    }
  }
}
</style>
<style>
.van-tabs__line {
  background-color: #0751A8;
}
.org-search .van-cell {
  background-color: #f9f9f9;
  margin: 0.32rem;
  width: auto;
  border-radius: 0.2rem;
}
.org-search .van-cell::after {
  display: none;
}
.org-search .primary-btn {
  border-radius: 0.2rem;
  
}
</style>